// Module
var code = "<div class=row> <div class=col-lg-6> <node-info></node-info> </div> <div class=col-lg-6> <rpc-calls></rpc-calls> </div> </div> ";
// Exports
module.exports = code;